import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BuilderTabs from "../../../Layouts/BuilderTabs";
import Loader from "../../../Layouts/Loader/Loader";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import SearchQuery from "../../../components/BuilderComponents/SearchQuery";

import Button from "../../../components/FormComponents/Button";
import AppLeftSideBar from "../../../components/SideBar/AppLeftSideBar";
import { useAuth0Context } from "../../../context/Auth0Context";
import { useModalContext } from "../../../context/ModalContext";
import AddTheme from "../AddTheme";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { NoThemeFound, ThemeCard } from "../ThemeSection";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";

const themeAccessOnly = ["admin", "super-admin"];
const OrgThemeSection = () => {
  const params = useParams();
  const [themes, setThemes] = useState([]);
  const [addClick, setAddClick] = useState(false);
  // const [iframeOpen, setIframeOpen] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredThemes, setFilteredThemes] = useState(themes);
  const { getUserConfirmationForDelete } = useModalContext();
  const { user } = useAuth0Context();
  const userCanDoActionOnTheme = user.role_names.some((role) => themeAccessOnly.includes(role));
  const [deviceFilter, setDeviceFilter] = useState("desktop");
  const navigate = useNavigate();

  const getThemes = async () => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(`/screentheme/sysconfigs/type/theme`);
      setThemes(data);
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
    }
  };

  // edit theme
  const handleUpdateTheme = (e, theme) => {
    e.stopPropagation();
    navigate(`/organization/${params.orgId}/theme/${theme.id}`);
  };

  // delete theme
  const handleDeleteTheme = async (e, id, name) => {
    e.stopPropagation();
    try {
      const userConfirmed = await getUserConfirmationForDelete(name, "app");
      if (!userConfirmed) return;

      const { message } = await axiosInstance.delete(`/screentheme/sysconfigs/${id}`);
      // setIsModalOpen("");
      setThemes((prevThemes) => prevThemes.filter((themeList) => themeList.id !== id));
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    getThemes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const orgdesktopThemes = filteredThemes.filter(
    (theme) => theme.config.device === "org_desktop" && theme.org_id === params.orgId
  );
  const orgmobileThemes = filteredThemes.filter(
    (theme) => theme.config.device === "org_mobile" && theme.org_id === params.orgId
  );
  const orgtabletThemes = filteredThemes.filter(
    (theme) => theme.config.device === "org_tablet" && theme.org_id === params.orgId
  );

  const sortThemesAlphabetically = (themes) => {
    return [...themes].sort((a, b) => a.name.localeCompare(b.name));
  };
  const renderThemes = (themes, deviceType, handleUpdateTheme, handleDeleteTheme) => {
    const filteredThemes = themes.filter((theme) => theme.config.device === deviceType);

    return filteredThemes.length > 0 ? (
      sortThemesAlphabetically(filteredThemes).map((theme) => (
        <ThemeCard
          key={theme.id}
          theme={theme}
          handleUpdateTheme={handleUpdateTheme}
          handleDeleteTheme={handleDeleteTheme}
          userCanDoActionOnTheme={userCanDoActionOnTheme}
        />
      ))
    ) : (
      <NoThemeFound />
    );
  };

  const allTabs = [
    {
      label: "Desktop",
      content: (
        <div className="theme_iframe_container">
          {renderThemes(orgdesktopThemes, "org_desktop", handleUpdateTheme, handleDeleteTheme)}
        </div>
      )
    },
    {
      label: "Mobile",
      content: (
        <div className="theme_iframe_container">
          {renderThemes(orgmobileThemes, "org_mobile", handleUpdateTheme, handleDeleteTheme)}
        </div>
      )
    },
    {
      label: "Tablet",
      content: (
        <div className="theme_iframe_container">
          {renderThemes(orgtabletThemes, "org_tablet", handleUpdateTheme, handleDeleteTheme)}
        </div>
      )
    }
  ];

  const handleTabChange = (label) => {
    setDeviceFilter(label.toLowerCase());
  };

  return (
    <div className="application_container">
      <AppLeftSideBar type={params.orgId ? "app" : "org"} />
      <div className="page_section">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="theme_container">
            <div className="add_theme_container">
              <div className="d_flex align_center pt_4 pl_4 pr_4">
                <h2>Themes</h2>
                <div className="d_flex align_center ml_auto gap_3">
                  <SearchQuery
                    data={themes || []}
                    searchKey="name"
                    onSearch={setFilteredThemes}
                    placeholder="Search Themes"
                  />
                  <Button
                    type="add"
                    variant="primary"
                    size="medium"
                    onClick={() => setAddClick(true)}
                    style={{ height: "36px" }}
                  >
                    <MaterialIcon name="add" style={{ fontSize: "20px", marginRight: "6px" }} />
                    New Theme
                  </Button>
                </div>
              </div>
            </div>
            <div className="update_theme_container">
              <BuilderTabs
                tabs={allTabs}
                containerClass="themes_tabs ml_4"
                contentClass="screen_template_tabs_container"
                onChange={handleTabChange}
              />
            </div>
          </div>
        )}
      </div>

      <BuilderModal isOpen={addClick} onClose={() => setAddClick(false)} modalName="Add Theme">
        <AddTheme setThemes={setThemes} onClose={() => setAddClick(false)} deviceFilter={deviceFilter} from="org" />
      </BuilderModal>
    </div>
  );
};

export default OrgThemeSection;
